"use client"

import type React from "react"
import { useState } from "react"
import { CalendarIcon } from "lucide-react"

interface DatePickerProps {
  selected: Date | null
  onChange: (date: Date | null) => void
  placeholderText: string
  minDate?: Date
}

const DatePicker: React.FC<DatePickerProps> = ({ selected, onChange, placeholderText, minDate }) => {
  const [isOpen, setIsOpen] = useState(false)

  const formatDate = (date: Date) => {
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    })
  }

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const date = e.target.value ? new Date(e.target.value) : null
    onChange(date)
  }

  const getMinDateString = () => {
    if (!minDate) return undefined
    return minDate.toISOString().split("T")[0]
  }

  return (
    <div className="relative">
      <div className="relative">
        <input
          type="date"
          value={selected ? selected.toISOString().split("T")[0] : ""}
          onChange={handleDateChange}
          min={getMinDateString()}
          className="w-full h-10 sm:h-12 pl-10 pr-3 text-sm sm:text-base bg-white border-2 border-gray-200 hover:border-blue-300 transition-all duration-200 rounded-md focus:outline-none focus:border-blue-500"
        />
        <CalendarIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 sm:h-5 sm:w-5 text-gray-400" />
      </div>
    </div>
  )
}

export default DatePicker
